import style, { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'Rawline';
    src: url('/fonts/Rawline/rawline-600.ttf') format('truetype');
  }
`;

export const ButtonContainer = style.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background-color: #f8f8f8;
  border-radius: 100px;
  width: 180px;
  cursor: pointer;
  min-height: 40px;

  &:hover {
    background-color: #d6ddec;
  }
`;

export const ButtonText = style.span`
  color: #1351b4;
  font-family: 'Rawline', serif;
`;

export const ButtonImage = style.img`
  width: auto;
  height: 20px;
`;
